<template>

	<v-container
		class="fill-height"
		fluid
	>
  <a href="/" style="position: fixed;right:5px;top:0">Planetas</a>


		<v-row>
			<v-col cols="12">
				<v-row
					align="start"
					justify="center"
					class=""
				>

				<v-card
					class="pa-1"
					flat
				>
						<ul style="list-style:none;padding-left:0px" id="example-1">
							<li v-for="item in items1" :key="item.file">
								<drag class="drag"
									:image="require('../assets/circles/' + item.file + '.png')"
									:transfer-data="item"
									:image-x-offset="offset"
									:image-y-offset="offset"
                  style="pointer-events: mask;"
								>

									<v-img
                  style="width:110px"
									:src="require('../assets/circles/' + item.file + '.png')"
									class="msy-3"
									/>
								</drag>
							</li>
						</ul>
					</v-card>
					<v-card
						class="px-2"
						flat
					>

						<drop
							class="drop"
							@drop="handleDrop"
						>


							<v-img
								:src="require('../assets/mandala.png')"
								class="my-3"
								width="500"
							/>

							<div  v-for="item in droppedImages" :key="item.file">

							
								<drag class="drag"
									:image="require('../assets/circles/' + item.file + '.png')"
									:transfer-data="item"
									:image-x-offset="55"
									:image-y-offset="55"
                  style="pointer-events: mask;"
                   :hide-image-html="false"
v-on:dblclick.native="removePlanet(item)"

								>

									<v-img
										:src="require('../assets/circles/' + item.file + '.png')"
										class="may-3"
										:style="'width:110px;position:fixed;top: '+item.y + 'px;left: '+item.x + 'px'"



										/>
								</drag>
							</div>
						</drop>

					</v-card>
					<v-card
						class="pa-2"
						flat
						
					>
						<ul style="list-style:none;padding-left:0px" id="example-2">
							<li v-for="item in items2" :key="item.file">
								<drag class="drag"
									:image="require('../assets/circles/' + item.file + '.png')"
									:transfer-data="item"
									:image-x-offset="offset"
									:image-y-offset="offset"

                  style="pointer-events: mask;"
								>

									<v-img
									:src="require('../assets/circles/' + item.file + '.png')"
									class="msy-3"
                  style="width:110px"
									/>
								</drag>
							</li>
						</ul>
					</v-card>
				</v-row>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'

	import { Drag, Drop } from 'vue-drag-drop';

import Vue from 'vue'

export default {
  name: 'Fichas',
	mounted(){

    if(window.devicePixelRatio == 1){
      this.offset = 55;
    }else{
      if(window.devicePixelRatio == 1.25){
        this.offset = 85;
      }
    }
    
	},
	methods: {
		removePlanet(data) {

			console.log("removePlanet: ", data);
      
			for (var x=0; x < this.droppedImages.length; x++) {
				if (this.droppedImages[x].file === data.file) {
					Vue.delete(this.droppedImages, x)
					break;
				}
			}
    },
		handleDrop(data, evt) {
			//debugger;
			console.log("handleDrop: ", data);
			let i = -1;
			for (var x=0; x < this.droppedImages.length; x++) {
				if (this.droppedImages[x].file === data.file) {
					i = x;
					break;
				}
			}

			if(i == -1){

				Vue.set(data, 'x', evt.clientX - 55);
				Vue.set(data, 'y', evt.clientY - 55);
				this.droppedImages.push(data);

			}else{
        
			console.log("existe ", data.file);
				let obj = this.droppedImages[i];
				obj.x = evt.clientX - 55;
				obj.y = evt.clientY - 55;
				Vue.set(this.droppedImages, i, obj);

			}
			
			///&/console.log(obj);
			//if(obj === undefined){
			//s}
			//console.log(data);
			//console.log(evt);
		},
	},
	data: function() {
		return {
      offset: 125,
			loading: true,
			droppedImages: [],

			items1: [
				{ 
					file: "1",
				},
				{ 
					file: "2",
				},
				{ 
					file: "3",
				},
				{ 
					file: "4",
				},
				{ 
					file: "5",
				}
			],
			items2: [
				{ 
					file: "6",
				},
				{ 
					file: "7",
				},
				{ 
					file: "8",
				},
				{ 
					file: "9",
				},
				{ 
					file: "10",
				}
			],
		};
	},
		components: { Drag, Drop }
}
</script>
